module.exports = [{
      plugin: require('/Users/josephjung/projects/prolific/church/church-fe3/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
